module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticStyle: {
      "background": "#fff",
      "height": "1000px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "width": "70%",
      "margin": "0 auto"
    }
  }, [_c('el-row', [_c('el-row', {
    staticClass: "banner"
  }, [_c('el-row', {
    staticClass: "head"
  }, [_c('el-col', {
    staticClass: "head_logo",
    attrs: {
      "span": 22
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.log1,
      "height": "46px"
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "head_right",
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticClass: "Head_Link"
  }, [_c('el-button', {
    staticClass: "t",
    staticStyle: {
      "padding-left": "40px"
    },
    style: (_vm.dh),
    attrs: {
      "type": "text"
    }
  }, [_vm._v("\n                 400-878-6390\n              ")])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content main"
  }, [_c('div', {
    staticClass: "jf"
  }, [_c('div', {
    staticClass: "dlck",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("\n                    西安翻译学院\n              ")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "14px"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.global.curUser,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学生类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "== 请选择 =="
    },
    model: {
      value: (_vm.form.studentType),
      callback: function($$v) {
        _vm.$set(_vm.form, "studentType", $$v)
      },
      expression: "form.studentType"
    }
  }, _vm._l((_vm.stuTypeList), function(option) {
    return _c('el-option', {
      key: option.modeId,
      class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学生姓名"
    }
  }, [_c('el-input', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.form.studentName),
      callback: function($$v) {
        _vm.$set(_vm.form, "studentName", $$v)
      },
      expression: "form.studentName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.idCardVisible),
      expression: "idCardVisible"
    }],
    attrs: {
      "label": "身份证号"
    }
  }, [_c('el-input', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.form.idCard),
      callback: function($$v) {
        _vm.$set(_vm.form, "idCard", $$v)
      },
      expression: "form.idCard"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.studentNoVisible),
      expression: "studentNoVisible"
    }],
    attrs: {
      "label": "学号"
    }
  }, [_c('el-input', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.form.studentNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "studentNo", $$v)
      },
      expression: "form.studentNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeVisible),
      expression: "codeVisible"
    }],
    attrs: {
      "label": "验证码"
    }
  }, [_c('el-input', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "请输入身份证号后六位"
    },
    model: {
      value: (_vm.form.code),
      callback: function($$v) {
        _vm.$set(_vm.form, "code", $$v)
      },
      expression: "form.code"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "width": "100%",
      "margin": "20px auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.loginInit()
      }
    }
  }, [_vm._v("登录")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "545px",
      "height": "330px",
      "float": "right",
      "margin-top": "10px"
    }
  }, [_c('el-carousel', {
    attrs: {
      "indicator-position": "outside"
    }
  }, [_c('el-carousel-item', [_c('img', {
    attrs: {
      "src": _vm.fy1,
      "height": "300px",
      "width": "545px"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": _vm.fy2,
      "height": "300px",
      "width": "545px"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": _vm.fy3,
      "height": "300px",
      "width": "545px"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": _vm.fy4,
      "height": "300px",
      "width": "545px"
    }
  })])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tybottom"
  }, [_c('div', {
    staticClass: "main_down"
  }, [_c('div', {
    staticClass: "down_gg fl"
  }, [_c('h2', [_vm._v("咨询电话")]), _vm._v(" "), _c('ul', {
    staticClass: "gg"
  }, [(!(_vm.financeOffice.modeName === undefined)) ? _c('li', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.financeOffice.modeName) + "：" + _vm._s(_vm.financeOffice.modeValue))])]) : _vm._e(), _vm._v(" "), (!(_vm.apartmentOffice.modeName === undefined)) ? _c('li', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.apartmentOffice.modeName) + "：" + _vm._s(_vm.apartmentOffice.modeValue))])]) : _vm._e(), _vm._v(" "), (!(_vm.deanOffice.modeName === undefined)) ? _c('li', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.deanOffice.modeName) + "：" + _vm._s(_vm.deanOffice.modeValue))])]) : _vm._e(), _vm._v(" "), (!(_vm.admissionsOffice.modeName === undefined)) ? _c('li', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.admissionsOffice.modeName) + "：" + _vm._s(_vm.admissionsOffice.modeValue))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "down_gg fr"
  }, [_c('h2', [_vm._v("帮助电话")]), _vm._v(" "), _c('ul', {
    staticClass: "bzzx"
  }, [(!(_vm.technicalSupport.modeName === undefined)) ? _c('li', [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.technicalSupport.modeName) + "：" + _vm._s(_vm.technicalSupport.modeValue))])]) : _vm._e()])])])]), _vm._v(" "), _c('div', [_c('router-view')], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-282933c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/XiFan/LoginXiFan.vue
// module id = 1268
// module chunks = 1